<template>
  <div>
    <v-layout
      v-if="componentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <div
      v-else
    >
      <visitor-log-table />
      <visitor-log-chart />
    </div>
  </div>
</template>
<script>
import VisitorLogTable from '@/components/max-admin/vms/visitor-log/VisitorLogTable';
import VisitorLogChart from '@/components/max-admin/vms/visitor-log/VisitorLogChart';
export default {
  name: 'VisitorLogWidgets',
  components: {
    'visitor-log-table': VisitorLogTable,
    'visitor-log-chart': VisitorLogChart
  },
  data() {
    return {
      componentLoading: true
    };
  },
  mounted() {
    this.componentLoading = false;
  }
};
</script>

